import {Button} from "semantic-ui-react";
import styled from "styled-components";

export const DangerButton = styled(Button)`
  background: white!important;
  color: #f70000!important;;
  border: 2px solid #f70000!important;;
  border-radius: 0!important;;

  &:hover {
    background: #f70000!important;;
    color: white!important;;
  }
`;


/**


 .ui.button.whiteButton {
    background: white;
    color: black;
    border: 2px solid #000;
    border-radius: 0;
}

 .ui.button.whiteButton:hover {
    background: black;
    color: white;
}

 */
